;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Menu from "../Menu"
import MenuItem from "../MenuItem"
import CompactOrgSwitcher from "../CompactOrgSwitcher"
import MenuMemberAndLeaderHeader from "./MenuMemberAndLeaderHeader"
import ProviderSetupCard from "./ProviderSetupCard"
import {
  TOP_NAV_MENU_TYPE_ACCOUNT,
  TOP_NAV_MENU_TYPE_FIND_A_GROUP,
  TOP_NAV_MENU_TYPE_GROUPS_I_LEAD,
  TOP_NAV_MENU_TYPE_POST_A_NEW_GROUP,
  TOP_NAV_MENU_TYPE_ARTICLE_STUDIO,
  TOP_NAV_MENU_TYPE_LOGOUT,
  TOP_NAV_MENU_TYPE_NEWSLETTER_ACCOUNT_SETTING,
  TOP_NAV_MENU_TYPE_PROFILE,
  TOP_NAV_MENU_TYPE_ORGANIZATION_PAGE,
  TOP_NAV_MENU_TYPE_MESSAGES,
} from "../constants"

const PRIMARY_GROUP_CLASSES = "px-[5px] py-1"
const SECONDARY_GROUP_CLASSES =
  "border-t-[0.5px] border-solid border-t-[rgba(0,0,0,0.12)] px-[5px] py-1"

export default function MenuMemberAndLeader({
  activeStateType: _activeStateType,
  trigger,
  handleLogout,
  unreadMsgCount,
  setupStepsRemaining,
  setupTotalSteps,
  firstName,
  lastName,
  userId,
  orgId,
  organizationPageOrgId,
}: {
  activeStateType: string
  trigger: React.ReactElement
  handleLogout: () => void | Promise<void>
  unreadMsgCount: number
  setupStepsRemaining: number
  setupTotalSteps: number
  firstName?: string | null
  lastName?: string | null
  userId?: number | null
  orgId?: string | number | null
  organizationPageOrgId?: string
}) {
  return (
    <Menu trigger={trigger} appearance="zestlife">
      <MenuMemberAndLeaderHeader firstName={firstName} lastName={lastName} />
      <CompactOrgSwitcher userId={userId} orgId={orgId} menuEmbed />
      {/* Org-scoped */}
      <div className={PRIMARY_GROUP_CLASSES}>
        <ProviderSetupCard
          setupStepsRemaining={setupStepsRemaining}
          setupTotalSteps={setupTotalSteps}
        />
        {organizationPageOrgId ? (
          <MenuItem
            topNavMenuItemType={TOP_NAV_MENU_TYPE_ORGANIZATION_PAGE}
            organizationOrgId={organizationPageOrgId}
            dense
            iconTintZestlife
          />
        ) : null}
        <MenuItem
          topNavMenuItemType={TOP_NAV_MENU_TYPE_GROUPS_I_LEAD}
          dense
          iconTintZestlife
        />
        <MenuItem
          topNavMenuItemType={TOP_NAV_MENU_TYPE_POST_A_NEW_GROUP}
          dense
          iconTintZestlife
        />
        <MenuItem
          topNavMenuItemType={TOP_NAV_MENU_TYPE_ARTICLE_STUDIO}
          dense
          iconTintZestlife
        />
      </div>
      {/* Activity */}
      <div className={SECONDARY_GROUP_CLASSES}>
        <MenuItem
          topNavMenuItemType={TOP_NAV_MENU_TYPE_FIND_A_GROUP}
          dense
          iconTintZestlife
        />
        <MenuItem
          topNavMenuItemType={TOP_NAV_MENU_TYPE_NEWSLETTER_ACCOUNT_SETTING}
          dense
          iconTintZestlife
        />
        <MenuItem
          topNavMenuItemType={TOP_NAV_MENU_TYPE_MESSAGES}
          badgeCount={unreadMsgCount}
          messageBadgeStyle="trailing"
          dense
          iconTintZestlife
        />
      </div>
      {/* Personal */}
      <div className={SECONDARY_GROUP_CLASSES}>
        <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_PROFILE} dense iconMuted />
        <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_ACCOUNT} dense iconMuted />
      </div>
      <div className={SECONDARY_GROUP_CLASSES}>
        <MenuItem
          topNavMenuItemType={TOP_NAV_MENU_TYPE_LOGOUT}
          handleLogout={handleLogout}
          dense
          logoutVariant="danger"
        />
      </div>
    </Menu>
  )
}
